/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getActiveOffers} from '../api'

 export const useQueryGetActiveOffers = createReactQueryHook('getActiveOffers', getActiveOffers)
